import React from 'react'

function PrimaryFilterIconButton(props) {
  return (
    <div>
      <button className=" text-base rounded-md border primary_icon_btn transition-all duration-500" onClick={props.onClick}>{props.isClose?<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
<path d="M25.3337 14.0026C25.3337 7.74338 20.2596 2.66927 14.0003 2.66927C7.7411 2.66927 2.66699 7.74338 2.66699 14.0026C2.66699 20.2618 7.7411 25.3359 14.0003 25.3359C20.2596 25.3359 25.3337 20.2618 25.3337 14.0026Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10.7949 17.207L17.206 10.7959" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M17.2061 17.207L10.795 10.7959" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>:<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M4 21V14" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M4 10V3" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M12 21V12" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M12 8V3" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M20 21V16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M20 12V3" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M1 14H7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M9 8H15" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M17 16H23" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>}</button>
    </div>
  )
}

export default PrimaryFilterIconButton
